
<div>


  <mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="{{'enterKeyWord' |translation}}">
  </mat-form-field>

  <div class="mat-table-wrapper mat-elevation-z8">
    <table matSort matTableExporter mat-table [dataSource]="displayDataSources" #exporter="matTableExporter"
           #dataTable>

      <ng-container *ngFor="let columns of displayedColumns" [matColumnDef]="columns">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{columns}} </th>
        <td mat-cell *matCellDef="let element">
        <!--  <ng-container *ngIf="containImage">


            <ng-container *ngIf="checkIfUrl(element, columns); else default">
              <img class="thumbnail" [src]="element[columns]" (click)="openImage(element, columns)" />
            </ng-container>
          </ng-container>
          <ng-template #default>
            {{element[columns]}}
          </ng-template>-->
          <app-table-element [content]="element[columns]"></app-table-element>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[25, 100]"></mat-paginator>
  </div>
</div>
